import {
    MAINTENANCE_WARNINGS_EVENTS_OPEN_MODAL
} from 'Redux/actionTypes';

export const maintenanceWarningsEventsOpenModal = (data, timezone) => ({
    type: MAINTENANCE_WARNINGS_EVENTS_OPEN_MODAL,
    payload: { data, timezone }
})